import { render, staticRenderFns } from "./overlay.vue?vue&type=template&id=532bfeaf&scoped=true"
import script from "./overlay.vue?vue&type=script&lang=js"
export * from "./overlay.vue?vue&type=script&lang=js"
import style0 from "./overlay.vue?vue&type=style&index=0&id=532bfeaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532bfeaf",
  null
  
)

export default component.exports